module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "ksm-footer ksm-disable-select",
    style: (_vm.isHome ? '' : 'height:8px')
  }, [_c('div', {
    staticClass: "ksm-footer__main"
  }, [_vm._l((_vm.footItemsLeft), function(it, i) {
    return [(!it.img && !it.png) ? _c('router-link', {
      key: 'r' + i,
      staticClass: "ksm-flex-xy-center ksm-link-text",
      staticStyle: {
        "height": "100%",
        "margin-right": "25px",
        "padding": "0"
      },
      attrs: {
        "to": it.url
      }
    }, [_vm._v(_vm._s(it.label))]) : _c('a', {
      key: 'm' + i,
      staticClass: "ksm-flex-xy-center ksm-link-img",
      staticStyle: {
        "height": "100%",
        "margin-right": "25px",
        "padding": "0"
      },
      attrs: {
        "href": it.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "ksm-flex-xy-center"
    }, [(it.img) ? _c('div', {
      style: (it.style),
      domProps: {
        "innerHTML": _vm._s(_vm.$_getSvg(it.img))
      }
    }) : _vm._e(), _vm._v(" "), (it.png) ? _c('div', {
      style: (it.style)
    }, [_c('img', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "src": _vm.$_getIcon(it.png)
      }
    })]) : _vm._e()])])]
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_vm._l((_vm.footItemsRight), function(it, j) {
    return [(j > 0) ? _c('div', {
      key: 's' + j,
      staticClass: "ksm-flex-xy-center"
    }, [_vm._v("|")]) : _vm._e(), _vm._v(" "), _c('router-link', {
      key: 'b' + j,
      staticClass: "ksm-link-text ksm-flex-xy-center",
      attrs: {
        "to": it.url
      }
    }, [_vm._v(_vm._s(it.label))])]
  })], 2)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98f1d2a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Footer.vue
// module id = 1988
// module chunks = 1